import type { Pos, FuelGrid, Direction } from "../types.ts";

export function createGrid(rows: number, cols: number, fill: number): FuelGrid {
  return Array.from({ length: rows }, () => Array(cols).fill(fill) as number[]);
}

export function cloneGrid(grid: FuelGrid): FuelGrid {
  return grid.map((row) => [...row]);
}

export function gridRows(grid: FuelGrid): number {
  return grid.length;
}

export function gridCols(grid: FuelGrid): number {
  return grid[0]?.length ?? 0;
}

export function inBounds(grid: FuelGrid, pos: Pos): boolean {
  return pos.row >= 0 && pos.row < gridRows(grid) && pos.col >= 0 && pos.col < gridCols(grid);
}

export function getFuel(grid: FuelGrid, pos: Pos): number {
  return grid[pos.row]?.[pos.col] ?? 0;
}

export function setFuel(grid: FuelGrid, pos: Pos, value: number): void {
  if (grid[pos.row]) {
    grid[pos.row]![pos.col] = value;
  }
}

export function totalFuel(grid: FuelGrid): number {
  let sum = 0;
  for (const row of grid) {
    for (const cell of row) {
      sum += cell;
    }
  }
  return sum;
}

export function getNeighbor(pos: Pos, dir: Direction): Pos {
  switch (dir) {
    case "up": return { row: pos.row - 1, col: pos.col };
    case "down": return { row: pos.row + 1, col: pos.col };
    case "left": return { row: pos.row, col: pos.col - 1 };
    case "right": return { row: pos.row, col: pos.col + 1 };
  }
}

export function getNeighbors(grid: FuelGrid, pos: Pos): Pos[] {
  const dirs: Direction[] = ["up", "down", "left", "right"];
  return dirs.map((d) => getNeighbor(pos, d)).filter((p) => inBounds(grid, p));
}

export function posEq(a: Pos, b: Pos): boolean {
  return a.row === b.row && a.col === b.col;
}

export function posKey(pos: Pos): string {
  return `${pos.row},${pos.col}`;
}
